export const ElementaryCategorySlug = 'k-5'
export const EarlyChildhoodCategorySlug = 'pre-k'
export const MiddleSchoolCategorySlug = 'middle-school'
